import { config } from "shared/data";

export const AIWidgetApiTimeoutMS = 10_000;

export const AIWidgetApiEndpoint = `${config.abWidgetApi.host}/recommend/v2`;

export const AIWidgetFetchLogPrefix = "[AI Widget Fetch]";
